var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * 签名
 */
// 注意按需引用, 控制包大小
import WordArray from 'crypto-js/lib-typedarrays';
import SHA256 from 'crypto-js/sha256';
import axios from 'axios';
var salt = 'i9iceacsiiuepm7ndehwrngwsahd4aks5t9ue8jes7yaao3kc3ehmpkv1rmtqyovyyh4pobo40phpmxww';
/**
 * 服务器时间差缓存key
 */
var ServerTimeDiffCacheKey = 'vb_server_time_diff';
// 获取服务器时间（内存级缓存）
var getServerTimePromise = null;
/**
 * 纯H5页面对请求内容加签
 * @queryStr 请求的query参数
 * @bodyStr  请求的body参数
 * 对query参数的value进行了encode编码 需要拿到编码后的query替换 再进行请求
 */
export function doSignQueryBody(queryStr, bodyStr) {
    if (queryStr === void 0) { queryStr = ''; }
    if (bodyStr === void 0) { bodyStr = ''; }
    return __awaiter(this, void 0, void 0, function () {
        var queryArray, nonce, timeDiff, timestamp, originStr, seckey;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    queryArray = queryStr.split('&');
                    queryArray = queryArray.map(function (queryItem) {
                        if (queryItem) {
                            var _a = queryItem.split('='), itemKey = _a[0], itemValue = _a[1];
                            return "".concat(itemKey, "=").concat(encodeURIComponent(itemValue));
                        }
                        return '';
                    });
                    queryArray = queryArray.filter(function (item) { return item.length > 0; });
                    nonce = WordArray.random(12).toString();
                    // 时间戳（对齐服务器时间）
                    // 内存级缓存，复用第一个获取服务器时间的请求
                    // 服务器时间校准的原因是：java和tws做了时间戳的准确性（5min内偏差）校验
                    if (!getServerTimePromise) {
                        getServerTimePromise = getServerTimeDiff();
                    }
                    return [4 /*yield*/, getServerTimePromise];
                case 1:
                    timeDiff = _a.sent();
                    console.log('timeDiff', timeDiff);
                    timestamp = (Date.now() + timeDiff).toString();
                    queryArray = queryArray.concat("nonce=".concat(nonce), "timestamp=".concat(timestamp));
                    originStr = queryArray
                        .sort(function (a, b) { return (a > b ? 1 : -1); })
                        .reduce(function (str, kv) {
                        var _a = kv.split('='), key = _a[0], value = _a[1];
                        return "".concat(str).concat(key).concat(value);
                    }, '');
                    seckey = SHA256(originStr + salt + bodyStr).toString();
                    queryArray = queryArray.concat("seckey=".concat(seckey));
                    return [2 /*return*/, {
                            nonce: nonce,
                            timestamp: timestamp,
                            seckey: seckey,
                            queryString: queryArray.join('&'),
                        }];
            }
        });
    });
}
/**
 * 从缓存获取服务器时间差
 * 注意：
 * 返回 null 表示缓存中不存在
 * @returns number|null
 */
var getServerTimeDiffFromCache = function () {
    var a = sessionStorage.getItem(ServerTimeDiffCacheKey);
    if (a === null) {
        return null;
    }
    return +a;
};
/**
 * 往缓存中写入服务器时间差
 * @param value
 */
var setServerTimeDiffToCache = function (value) {
    sessionStorage.setItem(ServerTimeDiffCacheKey, value.toString());
};
/**
 * 使用一个 head 请求来校准本地时间
 * 备注：
 * 1. 策略：请求失败，默认客户端与服务端没有时间差
 * 2. 这个时间差不是准确的，包含了请求传输的时间，但够用，因为后端校验时间戳允许5min的偏差
 * 3. 为了优化性能，进行下面两个措施：
 * 3.1 优先从全局变量（nginx ssi 注入）获取，并写入缓存
 * 3.2 全局变量中没有，则从session storage获取
 * 3.3 都没有，则请求获取，并写入session storage
 */
function getServerTimeDiff() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var DefaultResult, result, resultFromCache, res, serverTime, result, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    DefaultResult = 0;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    // 优先从全局变量中获取，获取到顺便写入sessionstorage
                    if (window.__$$_serverTimeDiff) {
                        result = window.__$$_serverTimeDiff;
                        setServerTimeDiffToCache(result);
                        return [2 /*return*/, result];
                    }
                    resultFromCache = getServerTimeDiffFromCache();
                    if (resultFromCache !== null) {
                        return [2 /*return*/, resultFromCache];
                    }
                    return [4 /*yield*/, axios.head("".concat(location.pathname, "?_t=").concat(Date.now()), { timeout: 500 })];
                case 2:
                    res = _b.sent();
                    serverTime = new Date((_a = res.headers) === null || _a === void 0 ? void 0 : _a.date).getTime();
                    if (!isNaN(serverTime)) {
                        result = serverTime - Date.now();
                        setServerTimeDiffToCache(result);
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/, DefaultResult];
                case 3:
                    e_1 = _b.sent();
                    // 策略：请求失败，默认客户端与服务端没有时间差
                    console.error(e_1);
                    return [2 /*return*/, DefaultResult];
                case 4: return [2 /*return*/];
            }
        });
    });
}
